import { Reducer, useReducer } from "react";

export const useSimpleReducer = <T,>(initialState: T) =>
  useReducer<Reducer<T, Partial<T>>>(
    (state, changes) => ({ ...state, ...changes }),
    initialState
  );
